import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-customize-builder-back.svg'
import _imports_1 from '@/assets/icons/logo-white.svg'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = {
  key: 0,
  class: "loading-wr"
}
const _hoisted_3 = {
  key: 1,
  class: "sidebar"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "spinner" }, null, -1)
      ]))]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (!$setup.canShowSuccessMessage)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button button-prev",
              onClick: $setup.onSelectPrev
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                class: "arrow",
                src: _imports_0
              }, null, -1),
              _createElementVNode("span", null, "Back", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!$setup.isFormOpen)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("img", {
                class: "builder-logo",
                src: $props.builderLogo
              }, null, 8, _hoisted_4),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "support-text" }, "Our friendly team are here to support you every step of the way. Contact us to finalise your quote and start your new home journey today.", -1)),
              _createElementVNode("div", { class: "button-container" }, [
                _createElementVNode("button", {
                  class: "button button-design",
                  onClick: $setup.onGetFreeDesign
                }, "Get your Free Home Design"),
                _createElementVNode("button", {
                  class: "button button-consultation",
                  onClick: $setup.onBookConsultation
                }, "Book a Free Design Consultation"),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "powered-container" }, [
                  _createElementVNode("p", null, "Powered by"),
                  _createElementVNode("img", {
                    src: _imports_1,
                    srcset: _hoisted_1,
                    alt: "Logo"
                  })
                ], -1))
              ])
            ], 64))
          : (!$setup.canShowSuccessMessage && $setup.isFormOpen)
            ? (_openBlock(), _createBlock($setup["BuilderEstimatorSummaryDesignForm"], {
                key: 2,
                "form-type": $setup.formTypeSelected,
                onSubmit: $setup.onFormSubmit
              }, null, 8, ["form-type"]))
            : ($setup.canShowSuccessMessage)
              ? (_openBlock(), _createBlock($setup["BuilderEstimatorSummarySuccessMessage"], {
                  key: 3,
                  onReset: $setup.resetForm
                }))
              : _createCommentVNode("", true)
      ]))
}